import React from 'react';
import { STORE_NOTIFICATION, STORE_COMMON } from '../../constants';
import { inject, observer } from 'mobx-react';
import { NotificationStore, NotificationLevel } from '../../stores/NotificationStore';



@inject(STORE_COMMON, STORE_NOTIFICATION)
@observer
export class NotificationSystem extends React.Component<{}> {

    notificationStore = (this.props as any)[STORE_NOTIFICATION] as NotificationStore;

    render() {


        return <div aria-live="polite" aria-atomic="true" style={{ position: "absolute", minHeight: "200px", top: "60px", right: 0, zIndex: 1200 }}>
            <div style={{ position: "absolute", top: 0, right: 0, padding: "10px" }}>

                {this.notificationStore.notifications.map(n => {

                    let header = "";
                    let borderColor = "rgba(0, 0, 0, 0.1)";
                    switch (n.level) {
                        case NotificationLevel.error:
                            header = "Ошибка";
                            borderColor = "rgba(255, 0, 0, 075)";
                            break;
                        case NotificationLevel.info:
                            header = "Информация";
                            borderColor = "rgba(87, 175, 247, 0.75)";
                            break;
                        case NotificationLevel.warning:
                            header = "Предупреждение";
                            borderColor = "rgba(247, 174, 87, 0.75)";
                            break;

                        default:
                            header = "Сообщение";
                            borderColor = "rgba(40, 167, 69, 0.75)";
                            break;
                    }

                    return <div className="toast" key={n.id} style={{ minWidth: "350px", opacity: 1, background: "#fff", borderColor: borderColor }}>
                        <div className="toast-header">
                            <strong className="mr-auto" style={{ color: borderColor }}>{header}</strong>
                            <button type="button" className="ml-2 mb-1 close" aria-label="Close" onClick={() => this.notificationStore.removeNotification(n.id)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="toast-body">
                            {(n.message || "").split("\r\n").map((w, index) => <div key={index}>{w}</div>)}
                        </div>
                    </div>
                })}
            </div>
        </div >
    }
}